import { render, staticRenderFns } from "./Noticias.vue?vue&type=template&id=15a1c27c"
import script from "./Noticias.vue?vue&type=script&lang=js"
export * from "./Noticias.vue?vue&type=script&lang=js"
import style0 from "./Noticias.vue?vue&type=style&index=0&id=15a1c27c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports